<span class="am-flex-align am-flex-shrink-0 gap-xxs pl-xs pr-xs font-s font-500 pointer hover-active" [ngClass]="selected ? 'color-secondary-grey' : 'color-blue'" [attr.data-active]="selected ? null : ''" (click)="selectTab.emit(null)">
  <span class="am-flex-center icon-chat font-l"></span>
  <span>Alle</span>
</span>
@for (room of rooms; track room.id) {
  <chat-box-header [room]="room" [active]="room.id === selected" [attr.data-active]="room.id === selected ? '' : null" [attr.title]="room.id === selected ? null : room.roomName" (click)="pick(room)"></chat-box-header>
}
@if (bulkMode) {
  @if (selected === BULK_TAB) {
    <span class="am-flex-align am-flex-shrink-0 gap-xxs pl-xs pr-xxs font-s font-500 color-blue" data-active>
      <span class="am-flex-center am-flex-shrink-0 icon-chat-send font-l"></span>
      <span>Gruppen-Chat</span>
      <span class="am-flex-center am-flex-shrink-0 icon-cross font-l p-xs b-radius mla hover-bg-soft-red" title="Tab schließen" (click)="closeBulk.emit()"></span>
    </span>
  } @else {
    <span class="am-flex-align am-flex-shrink-0 pl-xxs pr-xxs pointer hover-active" title="Gruppen-Chat" (click)="selectTab.emit(BULK_TAB)">
      <span class="circle-xxl am-flex-center bg-grey color-secondary-grey icon-chat-send font-l"></span>
    </span>
  }
}
<span data-indicator class="absolute bottom-0 height-xxxs bg-blue animate-left-width" [style.left.px]="indicator.left" [style.width.px]="indicator.width"></span>
